import styled from "styled-components";

export const BoldButton = styled.button`
	cursor: pointer;
	display: block;
	border: none;
	outline: none;
	font-size: 0.9375rem;
	color: ${({ theme }) => theme.colors.textPrimary};
	font-weight: bold;
	transition: color 0.1s linear;
	background: none;

	:hover  {
		color: ${({ theme }) => theme.colors.lightgray};
	}

	&:disabled {
		pointer-events: none;
		color: ${({ theme }) => theme.colors.lightgray};
		box-shadow: none;
	}
`;
